/**
 * Die App auf den Startbildschirm legen (Stufe 3, KONZEPT.md §19).
 *
 * Installiert startet sie ohne Adressleiste, im Vollbild und aus dem
 * Zwischenspeicher -- auch dann, wenn der Browser nicht mehr weiss, auf
 * welcher Seite man zuletzt war. An der Einsatzstelle sucht niemand ein
 * Lesezeichen.
 *
 * Android und Chrome bieten das Installieren selbst an; hier gibt es dafuer
 * einen Knopf. Das iPhone kennt das nicht -- dort steht, wo es geht.
 */

import { useEffect, useState } from "react";
import { Karte, Knopf } from "../ui/bausteine.jsx";

/** Das Ereignis, das Chrome vor dem Installieren schickt. Nicht in den DOM-Typen. */
interface InstallAufforderung extends Event {
  prompt: () => Promise<void>;
  userChoice: Promise<{ outcome: "accepted" | "dismissed" }>;
}

let aufgehoben: InstallAufforderung | null = null;

// So frueh wie moeglich mithoeren: Das Ereignis kommt einmal, meist bevor
// jemand die Kontoseite oeffnet.
globalThis.addEventListener("beforeinstallprompt", (e) => {
  e.preventDefault();
  aufgehoben = e as InstallAufforderung;
});

function installiert(): boolean {
  return globalThis.matchMedia("(display-mode: standalone)").matches;
}

function istIphone(): boolean {
  return /iPhone|iPad|iPod/.test(globalThis.navigator.userAgent);
}

export function Installieren() {
  const [aufforderung, setAufforderung] = useState<InstallAufforderung | null>(aufgehoben);
  const [fertig, setFertig] = useState(installiert);

  useEffect(() => {
    const merken = (e: Event): void => {
      e.preventDefault();
      aufgehoben = e as InstallAufforderung;
      setAufforderung(aufgehoben);
    };
    const erledigt = (): void => {
      setFertig(true);
    };
    globalThis.addEventListener("beforeinstallprompt", merken);
    globalThis.addEventListener("appinstalled", erledigt);
    return () => {
      globalThis.removeEventListener("beforeinstallprompt", merken);
      globalThis.removeEventListener("appinstalled", erledigt);
    };
  }, []);

  if (fertig) return null;
  if (aufforderung === null && !istIphone()) return null;

  return (
    <Karte titel="Als App installieren">
      <p className="text-sm text-neutral-600 dark:text-neutral-300">
        Auf dem Startbildschirm startet die App ohne Adressleiste und auch ohne Netz.
      </p>
      {aufforderung !== null ? (
        <Knopf
          art="haupt"
          onClick={() => {
            void aufforderung.prompt().then(async () => {
              const wahl = await aufforderung.userChoice;
              if (wahl.outcome === "accepted") setFertig(true);
              aufgehoben = null;
              setAufforderung(null);
            });
          }}
        >
          Auf den Startbildschirm
        </Knopf>
      ) : (
        <p className="text-sm font-semibold">
          Im Safari unten auf „Teilen“ tippen, dann „Zum Home-Bildschirm“.
        </p>
      )}
    </Karte>
  );
}
